import { render, staticRenderFns } from "./occupationPath.vue?vue&type=template&id=b9c62672&scoped=true"
import script from "./occupationPath.vue?vue&type=script&lang=js"
export * from "./occupationPath.vue?vue&type=script&lang=js"
import style0 from "./occupationPath.vue?vue&type=style&index=0&id=b9c62672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c62672",
  null
  
)

export default component.exports